import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { GraphicInfoConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/graphic-info/graphic-info-converter';
import { CustomGraphicInfoConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/custom-graphic-info/custom-graphic-info-converter';
import { FillConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/fill/fill-converter';
import { BorderConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/border/border-converter';
import { EffectConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/effect/effect-converter';
import { TextConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/text/text-converter';
import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { ICTTextBody, ICTShapeProperties, DeltaOf, ICTBlipFillProperties } from '@tencent/slide-sdk-model';
import {
    ElementCommonPropertyConverter,
} from '@src/slide/domain/ui-model/converter/node-property/element/element-common-property-converter';
import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';
import {
    PictureInfoConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/picture-info/picture-info-converter';
import {
    IPictureImage,
} from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/picture-model-props.interface';


export interface IChartBaseShapeProps { spPr?: ICTShapeProperties, txPr?: ICTTextBody }

export class ChartShapeInfoConverter {
    // eslint-disable-next-line complexity
    public static convertPartialDataFromSdkToUi(
        sdkShapePropsData: DeepReadonly<DeepPartial<IChartBaseShapeProps>>,
        uiShapePropsData: IShapeModel,
    ) {
        if (sdkShapePropsData.spPr) {
            uiShapePropsData.props = uiShapePropsData.props || {};
            uiShapePropsData.props.style = uiShapePropsData.props.style || {};

            if (sdkShapePropsData.spPr.prstGeom) {
                GraphicInfoConverter.convertPartialDataFromSdkToUi(
                    sdkShapePropsData.spPr.prstGeom,
                    uiShapePropsData.props.style,
                );
            }
            // 自定义图形信息转换
            if (sdkShapePropsData.spPr.custGeom) {
                CustomGraphicInfoConverter.convertPartialDataFromSdkToUi(
                    sdkShapePropsData.spPr.custGeom,
                    uiShapePropsData.props.style,
                );
            }
            // 填充
            if (FillConverter.needConvertSdkData(sdkShapePropsData.spPr || {})) {
                // 对齐以前逻辑，每次都重新覆盖一个新对象
                uiShapePropsData.props.style.fillBackground = {};
                FillConverter.convertPartialDataFromSdkToUi(
                    sdkShapePropsData.spPr,
                    uiShapePropsData.props.style.fillBackground,
                );
            }
            // 边框
            if (sdkShapePropsData?.spPr?.ln) {
                uiShapePropsData.props.style.border = uiShapePropsData.props.style.border || {};
                BorderConverter.convertPartialDataFromSdkToUi(
                    sdkShapePropsData.spPr.ln,
                    uiShapePropsData.props.style.border,
                );
            }
            // 效果
            if (sdkShapePropsData?.spPr?.effectLst) {
                uiShapePropsData.props.style.effect = uiShapePropsData.props.style.effect || {};
                EffectConverter.convertPartialDataFromSdkToUi(
                    sdkShapePropsData.spPr.effectLst,
                    uiShapePropsData.props.style.effect,
                );
            }
        }

        // 文本样式
        if (sdkShapePropsData.txPr) {
            this.convertTxBodySdkToUi(sdkShapePropsData.txPr, uiShapePropsData);
        }
    }

    // eslint-disable-next-line complexity
    public static convertPartialDataFromUiToSdk(
        uiShapePropsData: DeepPartial<IShapeModel>,
        sdkShapePropsData: DeltaOf<IChartBaseShapeProps>,
    ) {
        if (uiShapePropsData.props?.style) {
            sdkShapePropsData.spPr = sdkShapePropsData.spPr || {};
            // @ts-ignore TODO 看看rawUiData这样处理是否可行
            const rawUiData: IShapeModel = { props: { style: {} } };

            const style = uiShapePropsData.props?.style;
            ElementCommonPropertyConverter
                .convertPartialDataFromUiToSdk(uiShapePropsData, sdkShapePropsData, rawUiData);
            // 图形信息转换
            if (style?.bgShape || style?.controlValues) {
                if ((uiShapePropsData.props.style?.bgShape || rawUiData.props.style?.bgShape) !== ShapeType.custom) {
                    sdkShapePropsData.spPr.prstGeom = GraphicInfoConverter.convertPartialDataFromUiToSdk({
                        bgShape: style.bgShape,
                        controlValues: style.controlValues,
                    });
                    sdkShapePropsData.spPr.custGeom = null;
                } else {
                    sdkShapePropsData.spPr.custGeom = sdkShapePropsData.spPr.custGeom || {};
                    // 草绘 历史遗留 后续考虑优化
                    // @ts-ignore
                    const { customGeom } = style;
                    CustomGraphicInfoConverter
                        .convertPartialDataFromUiToSdk(customGeom, sdkShapePropsData.spPr.custGeom);
                }
            }
            // 填充
            if (style?.fillBackground) {
                FillConverter.convertPartialDataFromUiToSdk(style?.fillBackground, sdkShapePropsData.spPr);
                // 形状设置图片填充， 效果、矫正
                if (style?.fillBackground?.image) {
                    sdkShapePropsData.spPr.blipFill = sdkShapePropsData.spPr.blipFill || {};
                    PictureInfoConverter.convertImageImgPropsDataUiToSdk(
                        style?.fillBackground?.image as DeltaOf<IPictureImage>,
                        sdkShapePropsData.spPr.blipFill,
                        rawUiData.sdkData?.props?.spPr?.blipFill as ICTBlipFillProperties,
                    );
                }
            }
            // 边框
            if (style?.border) {
                sdkShapePropsData.spPr.ln = sdkShapePropsData.spPr.ln || {};
                BorderConverter.convertPartialDataFromUiToSdk(style.border, sdkShapePropsData.spPr.ln);
            }
            // 效果
            if (style?.effect) {
                sdkShapePropsData.spPr.effectLst = sdkShapePropsData.spPr.effectLst || {};
                EffectConverter.convertPartialDataFromUiToSdk(style?.effect, sdkShapePropsData.spPr.effectLst);
            }
        }

        if (uiShapePropsData.paragraphList) {
            sdkShapePropsData.txPr = sdkShapePropsData.txPr || {};
            this.convertTxBodyUiToSdk(uiShapePropsData, sdkShapePropsData.txPr);
        }
    }

    public static convertTxBodySdkToUi(sdkTxBodyData: DeepReadonly<DeepPartial<ICTTextBody>>, uiData: IShapeModel) {
        // 文本
        TextConverter.convertPartialDataFromSdkToUi(sdkTxBodyData, uiData);
    }

    public static convertTxBodyUiToSdk(
        uiData: DeepPartial<IShapeModel>,
        sdkTxBodyData: DeltaOf<ICTTextBody>,
    ) {
        if (uiData.paragraphList !== undefined) {
            uiData.paragraphList = uiData.paragraphList.map((p) => {
                if (p?.paragraphProps?.defaultRunProps) {
                    return {
                        ...p,
                        paragraphProps: {
                            ...p.paragraphProps,
                            'raw-defaultRunProps': true,
                        },
                    };
                }

                return p;
            });
        }

        TextConverter.convertPartialDataFromUiToSdk(uiData, sdkTxBodyData);
    }
}
